import mappingFields from '@/domain/data/installation/engineering/finalGradient/mappingFields';

const parametersFields = parameters => ({
  alarmTemperatureReachTime: {
    label: mappingFields.TempoAtingimentoTemperaturaAlarmeLabel,
    required: true,
    maxLength: 3,
    precision: 0,
    default: parameters.algorithmExecutionCycleTime,
    minValue: parameters.algorithmExecutionCycleTime,
    maxValue: 120,
    isMultiple: () => parameters.alarmTemperatureReachTime
      % parameters.algorithmExecutionCycleTime === 0,
  },
  shutdownTemperatureReachTime: {
    label: mappingFields.TempoAtingimentoTemperaturaDesligamentoLabel,
    required: true,
    maxLength: 3,
    precision: 0,
    default: parameters.algorithmExecutionCycleTime,
    minValue: parameters.algorithmExecutionCycleTime,
    maxValue: 120,
    isMultiple: () => parameters.shutdownTemperatureReachTime
      % parameters.algorithmExecutionCycleTime === 0,
  },
});

export default parametersFields;
